import { useCallback, useContext } from "react";
import { StepOneFormContext } from "../../../contexts/StepOneForm";
import { IndividualCheckedCells, SavedPreliquidation } from "../../../interfaces";
import PreLiquidationService from "../../../../../../../../shared/services/collection/preliquidation";
import { COLUMN_ACTION, COLUMN_TYPE, ColumnType } from "../../../../../shared/interfaces";
import { GenericDataFormContext } from "../../../../../shared/contexts/GenericDataForm";
import { message } from "antd";
import { DebtQuote } from "../../../../../shared/interfaces/services/get-debt-columns-service.interface";

export const useSaveQuotas = () => {

    const { preliquidationInfo } = useContext(GenericDataFormContext)

    const {
        checkboxList,
        preliquidationData,
        preliquidationDataWithFilters,
        savedPreliquidationData,
        setSavedPreliquidationData,
    } = useContext(StepOneFormContext);

    const getDataToSave = useCallback((): SavedPreliquidation => {
        const dataToSave: SavedPreliquidation = {
            fullCheckedColumns: [],
            individualCheckedCells: [],
        }

        const visibleItemsMap = new Map<string, DebtQuote>();
        (preliquidationDataWithFilters ?? []).forEach((item: DebtQuote) => {
            visibleItemsMap.set(item.key, item);
        });

        const currentData: DebtQuote[] = (preliquidationData ?? []).map((row: DebtQuote) => {
            const visibleRow = visibleItemsMap.get(row.key);

            if (!visibleRow) return row;

            return {
                ...row,
                deudaAnteriorOPT: visibleRow.deudaAnteriorOPT,
                quincenaAnteriorOPT: visibleRow.quincenaAnteriorOPT,
                quincenaActualOPT: visibleRow.quincenaActualOPT,
                quincenaSiguienteOPT: visibleRow.quincenaSiguienteOPT,
                quincenaPosteriorOPT: visibleRow.quincenaPosteriorOPT,
                saldoOPT: visibleRow.saldoOPT,
                pagoContadoOPT: visibleRow.pagoContadoOPT,
            };
        });

        if (currentData.length > 0) {
            checkboxList.forEach((checkbox: string) => {
                if (currentData.filter(item => (item as any)[checkbox] === true).length === currentData.length) {
                    dataToSave.fullCheckedColumns.push(checkbox);
                }
            });
        }

        const partialCheckedColumns: Array<string> = checkboxList.filter((col: string) => !dataToSave.fullCheckedColumns.includes(col)); // Array.from(new Set([...dataToSave.fullCheckedColumns, ...checkboxList]));

        //recupera las celdas marcadas por columnas que no fueron marcadas completamente
        currentData.forEach(row => {
            partialCheckedColumns.forEach(checkbox => {
                if ((row as any)[checkbox] === true && Number((row as any)[checkbox.split('OPT')[0]]) !== 0) {
                    dataToSave.individualCheckedCells.push({ key: row.key, colName: checkbox, articulo: row.articulo, superpoliza: row.superpoliza, suplemento: row.suplemento });
                }
            });
        });

        return dataToSave;
    }, [
        preliquidationData,
        preliquidationDataWithFilters,
        checkboxList,
    ]);

    const getColumnName = useCallback((colName: string): ColumnType => {

        const COLUMN_TYPE_CHECKBOX_NAME = {
            'deudaAnteriorOPT': COLUMN_TYPE.DEUDA_ANTERIOR,
            'quincenaAnteriorOPT': COLUMN_TYPE.QUINCENA_ANTERIOR,
            'quincenaActualOPT': COLUMN_TYPE.QUINCENA_ACTUAL,
            'quincenaSiguienteOPT': COLUMN_TYPE.QUINCENA_SIGUIENTE,
            'quincenaPosteriorOPT': COLUMN_TYPE.QUINCENA_POSTERIOR,
            'saldoOPT': COLUMN_TYPE.SALDO,
            'pagoContadoOPT': COLUMN_TYPE.CONTADO
        }
        return (COLUMN_TYPE_CHECKBOX_NAME as any)[colName];
    }, []);

    // const deselectOldColumns = useCallback(async (fullCheckedColumns: Array<string>) => {

    //     const columnsToDeselect: Array<Promise<AxiosResponse<SelectEntireColumnServiceResponse>>> = [];
    //     //Validar si hace falta desmarcar alguna columna guardada previamente
    //     savedPreliquidationData.fullCheckedColumns.forEach((colName) => {
    //         if (!fullCheckedColumns.find(col => col === colName)) {
    //             //Agrega la petición
    //             columnsToDeselect.push(PreLiquidationService.selectEntireColumn({
    //                 accion: COLUMN_ACTION.UNCHECK,
    //                 columna: getColumnName(colName),
    //                 numeroPreliquidacion: preliquidationInfo!.numeroPreliquidacion
    //             }));
    //         }
    //     });

    //     await Promise.all(columnsToDeselect)
    //         .then((values) => {
    //             /* Nothing... */
    //         })
    //         .catch((reason) => {
    //             //! TODO: Cortar flujo!!
    //             throw new Error(reason);
    //         });
    // }, [
    //     savedPreliquidationData,
    //     getColumnName,
    //     preliquidationInfo,
    // ]);

    // const deselectOldCheckboxes = useCallback(async (individualCheckedCells: Array<IndividualCheckedCells>) => {
    //     try {
    //         const checkboxesToDeselect: Array<Promise<AxiosResponse<SelectSuperPolicyEntireColumnServiceResponse>>> = [];
    //         //Validar si hace falta desmarcar algun checkbox guardada previamente
    
    //         savedPreliquidationData.individualCheckedCells.forEach((checkbox) => {
    //             if (!individualCheckedCells.find(col => col.key === checkbox.key && col.colName === checkbox.colName)) {
    //                 //Agrega la petición
    //                 checkboxesToDeselect.push(PreLiquidationService.selectSuperPolicyEntireColumn({
    //                     accion: COLUMN_ACTION.UNCHECK,
    //                     articulo: checkbox.articulo,
    //                     columna: getColumnName(checkbox.colName),
    //                     numeroPreliquidacion: preliquidationInfo!.numeroPreliquidacion,
    //                     superpoliza: checkbox.superpoliza,
    //                     suplemento: checkbox.suplemento,
    //                 }));                
    //             };
    //         });
    
    //         //Divide las peticiones en pedazos de 10 o menos
    //         const chunkSize = 10;
    //         for (let i = 0; i < checkboxesToDeselect.length; i += chunkSize) {
    //             const chunk = checkboxesToDeselect.slice(i, i + chunkSize);
    
    //             await Promise.all(chunk)
    //                 .then((values) => {
    //                     /* Nothing... */
    //                 })
    //                 .catch((reason) => {
    //                     //! TODO: Cortar flujo!!
    //                     throw new Error(reason);
    //                 });
    
    //             await delay(500);
    //         };
    //     } catch (error) {};
    // }, [
    //     savedPreliquidationData,
    //     getColumnName,
    //     preliquidationInfo,
    // ])

    // const saveNewColumns = useCallback(async (fullCheckedColumns: Array<string>) => {

    //     const columnsToSelect: Array<Promise<AxiosResponse<SelectEntireColumnServiceResponse>>> = [];

    //     const filteredCheckedCells = fullCheckedColumns.filter(el => !savedPreliquidationData.fullCheckedColumns.find(element => element === el));

    //     //Genera el listado de peticiones
    //     filteredCheckedCells.forEach((colName) => {
    //         //Agrega la petición
    //         columnsToSelect.push(PreLiquidationService.selectEntireColumn({
    //             accion: COLUMN_ACTION.CHECK,
    //             columna: getColumnName(colName),
    //             numeroPreliquidacion: preliquidationInfo!.numeroPreliquidacion
    //         }));
    //     });

    //     await Promise.all(columnsToSelect)
    //         .then((values) => {
    //             /* Nothing... */
    //         })
    //         .catch((reason) => {
    //             //! TODO: Cortar flujo!!
    //             throw new Error(reason);
    //         });
    // }, [
    //     getColumnName,
    //     preliquidationInfo,
    //     savedPreliquidationData,
    // ])

    // const saveNewCheckboxes = useCallback(async (individualCheckedCells: Array<IndividualCheckedCells>) => {
    //     try {
    //         const checkboxesToSelect: Array<Promise<AxiosResponse<SelectSuperPolicyEntireColumnServiceResponse>>> = [];

    //         const filteredCheckedCells = individualCheckedCells.filter(
    //             el => !savedPreliquidationData.individualCheckedCells.some(element => ( element.key === el.key && element.colName === el.colName))
    //         );
    
    //         //Genera el listado de peticiones
    //         filteredCheckedCells.forEach((checkbox) => {
    //             //Agrega la petición
    //             checkboxesToSelect.push(PreLiquidationService.selectSuperPolicyEntireColumn({
    //                 accion: COLUMN_ACTION.CHECK,
    //                 articulo: checkbox.articulo,
    //                 columna: getColumnName(checkbox.colName),
    //                 numeroPreliquidacion: preliquidationInfo!.numeroPreliquidacion,
    //                 superpoliza: checkbox.superpoliza,
    //                 suplemento: checkbox.suplemento,
    //             }));
    //         });
    
    //         //Divide las peticiones en pedazos de 10 o menos
    //         const chunkSize = 10;
    //         for (let i = 0; i < checkboxesToSelect.length; i += chunkSize) {
    //             const chunk = checkboxesToSelect.slice(i, i + chunkSize);
    
    //             await Promise.all(chunk)
    //                 .catch((reason) => {
    //                     //! TODO: Cortar flujo!!
    //                     throw new Error(reason);
    //                 });

    //             await delay(500);
    //         };
    //     } catch (error) {}
    // }, [
    //     getColumnName,
    //     preliquidationInfo,
    //     savedPreliquidationData
    // ]);

    /*  
        ? NOTA IMPORTANTE
        * El servidor se estaba cayendo al realizar tantas peticiones en paralelo, por lo que optamos
        * por llamar a los servicios de manera secuencial.
    */
    const deselectOldColumns = useCallback(async (fullCheckedColumns: Array<string>) => {
        try {
            for (const colName of savedPreliquidationData.fullCheckedColumns) {
                if (!fullCheckedColumns.includes(colName)) {
                    try {
                        await PreLiquidationService.selectEntireColumn({
                            accion: COLUMN_ACTION.UNCHECK,
                            columna: getColumnName(colName),
                            numeroPreliquidacion: preliquidationInfo!.numeroPreliquidacion
                        });
                        
                    } catch (error) {};
                };
            };
        } catch (error) {};
    }, [
        savedPreliquidationData,
        getColumnName,
        preliquidationInfo,
    ]);
    
    const deselectOldCheckboxes = useCallback(async (individualCheckedCells: Array<IndividualCheckedCells>) => {
        try {
            for (const checkbox of savedPreliquidationData.individualCheckedCells) {                
                if (!individualCheckedCells.some(col => col.key === checkbox.key && col.colName === checkbox.colName)) {
                    try {
                        await PreLiquidationService.selectSuperPolicyEntireColumn({
                            accion: COLUMN_ACTION.UNCHECK,
                            articulo: checkbox.articulo,
                            columna: getColumnName(checkbox.colName),
                            numeroPreliquidacion: preliquidationInfo!.numeroPreliquidacion,
                            superpoliza: checkbox.superpoliza,
                            suplemento: checkbox.suplemento,
                        });
                    } catch (error) {};
                };
            };
        } catch (error) {};
    }, [
        savedPreliquidationData,
        getColumnName,
        preliquidationInfo,
    ]);
    
    const saveNewColumns = useCallback(async (fullCheckedColumns: Array<string>) => {
        for (const colName of fullCheckedColumns) {
            try {
                await PreLiquidationService.selectEntireColumn({
                    accion: COLUMN_ACTION.CHECK,
                    columna: getColumnName(colName),
                    numeroPreliquidacion: preliquidationInfo!.numeroPreliquidacion
                });
            } catch (error) {
                message.error(`Ocurrio un fallo al intentar marcar la poliza comuniquese con el area de cobranzas`, 60);
                throw error;
            };
        };
        
    }, [
        getColumnName,
        preliquidationInfo,
    ]);

    const saveNewCheckboxes = useCallback(async (individualCheckedCells: Array<IndividualCheckedCells>) => {
        for (const checkbox of individualCheckedCells) {
            try {                
                await PreLiquidationService.selectSuperPolicyEntireColumn({
                    accion: COLUMN_ACTION.CHECK,
                    articulo: checkbox.articulo,
                    columna: getColumnName(checkbox.colName),
                    numeroPreliquidacion: preliquidationInfo!.numeroPreliquidacion,
                    superpoliza: checkbox.superpoliza,
                    suplemento: checkbox.suplemento,
                });
            } catch (error) {
                message.error(`Ocurrio un error al intentar marcar la poliza ${checkbox.superpoliza} comuniquese con el area de cobranzas`, 60);
                throw error;
            };
        };
    }, [
        getColumnName,
        preliquidationInfo,
    ]);
    

    const saveSelectedCells = useCallback(async () => {
        try {
            //Obtiene no los datos para marcar
            const dataToSave = getDataToSave();
    
            //Desmarca lo viejo
            await deselectOldColumns(dataToSave.fullCheckedColumns);
            await deselectOldCheckboxes(dataToSave.individualCheckedCells);
    
            //Marca lo nuevo
            await saveNewColumns(dataToSave.fullCheckedColumns);
            await saveNewCheckboxes(dataToSave.individualCheckedCells);
    
            //Guarda en el contexto lo ultimo registrado
            setSavedPreliquidationData(dataToSave);

            return true;
        } catch (error) {
            return false;
        }
    }, [
        getDataToSave,
        deselectOldColumns,
        deselectOldCheckboxes,
        saveNewColumns,
        saveNewCheckboxes,
        setSavedPreliquidationData,
    ]);

    return { saveSelectedCells, getDataToSave };
}; 